import { db } from '@/firebaseConfig'

const state = {
  locationsLoading: false,
  locations: [],
}

const getters = {
  locations: (state) => {
    return state.locations
  },
  locationsLoading: (state) => {
    return state.locationsLoading
  },
}

const mutations = {
  setLocations(state, newValue) {
    state.locations = newValue
  },
  setLocationsLoading(state, newValue) {
    state.locationsLoading = newValue
  },
}

const actions = {
  clearLocationsData({ commit }) {
    commit('setLocations', [])
    commit('setLocationsLoading', false)
  },

  async getLocations({ commit, rootState }, force = false) {
    if (!force && state.locations.length > 0) {
      return
    }

    commit('setLocationsLoading', true)
    const path = `companies/${rootState.company.companyId}/locations`
    try {
      const snapshot = await db.collection(path).get()
      const locations = snapshot.docs.map((l) => {
        return {
          id: l.id,
          ...l.data(),
        }
      })

      commit('setLocations', locations)
    } catch (error) {
      console.error(error)
    } finally {
      commit('setLocationsLoading', false)
    }
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
